import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;
const empty = { name: "", email: "", phone: "", message: "", consent: false, website: "" };

export const Field = ({ label, id, children }) => (
  <label htmlFor={id} className="block">
    <span className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">{label}</span>
    {children}
  </label>
);

export const ContactForm = () => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) return toast.error("Merci d’accepter la politique de confidentialité.");
    if (!API) return toast.error("Le formulaire est momentanément indisponible. Appelez-nous au 01 64 48 93 38.");
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Merci ! Votre message a bien été envoyé.");
      setForm(empty);
    } catch (err) {
      toast.error(err?.response?.data?.detail && typeof err.response.data.detail === "string" ? err.response.data.detail : "L’envoi a échoué. Merci de réessayer ou de nous appeler.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="rounded-3xl border border-[#D4A359]/20 bg-[#123322]/80 p-6 sm:p-10" data-testid="contact-form">
      <h2 className="font-display text-3xl sm:text-4xl">Écrivez-nous</h2>
      <div className="mt-8 grid gap-6 md:grid-cols-2">
        <Field label="Nom *" id="cf-name"><input id="cf-name" required maxLength={100} value={form.name} onChange={set("name")} className="field" data-testid="contact-form-name" /></Field>
        <Field label="E-mail *" id="cf-email"><input id="cf-email" type="email" required maxLength={150} value={form.email} onChange={set("email")} className="field" data-testid="contact-form-email" /></Field>
        <Field label="Téléphone (facultatif)" id="cf-phone"><input id="cf-phone" type="tel" maxLength={30} value={form.phone} onChange={set("phone")} className="field" data-testid="contact-form-phone" /></Field>
        <input tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
        <div className="md:col-span-2">
          <Field label="Message *" id="cf-message"><textarea id="cf-message" required rows={5} maxLength={3000} value={form.message} onChange={set("message")} className="field resize-y" data-testid="contact-form-message" /></Field>
        </div>
      </div>
      <label className="mt-6 flex items-start gap-3 text-sm text-[#D6CFC0] cursor-pointer">
        <input type="checkbox" checked={form.consent} onChange={set("consent")} className="mt-1 w-4 h-4 accent-[#D4A359]" data-testid="contact-form-consent" />
        <span>
          J’accepte que mes données soient utilisées par CAP SUD uniquement pour répondre à ma demande. Voir la{" "}
          <Link to="/politique-de-confidentialite" className="underline text-[#E5B66C]" data-testid="contact-form-privacy-link">politique de confidentialité</Link>.
        </span>
      </label>
      <div className="mt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <p className="text-xs text-[#A2B3A7]">* Champs obligatoires</p>
        <button type="submit" disabled={loading} className="btn-gold disabled:opacity-60" data-testid="contact-form-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer le message
        </button>
      </div>
    </form>
  );
};
